import React from 'react';

const ScrollingText = () => {
  return (
    <section className="scroll-section">
      <div className="scroll-container">
        {/* First Text Scrolling Right to Left */}
        <section className="news-message left-scroll">
          <p className="news-message-text">
            Our skilled developers and designers bring years of experience and creativity
          </p>
        </section>

        {/* Second Text Scrolling Left to Right */}
        <section className="news-message right-scroll">
          <p className="news-message-text">
            We stay ahead with the latest frameworks and tools, ensuring future-proof solutions
          </p>
        </section>
      </div>

      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Londrina+Sketch&display=swap');

          .scroll-section {
            color: black;
            font-family: "Londrina Sketch", serif;
            text-transform: uppercase;
            overflow-x: hidden; 
            white-space: nowrap;
          }

          .scroll-container {
            display: flex;
            flex-direction: column; 
          }

          .news-message {
            display: flex;
            flex-shrink: 0;
            align-items: center;
            white-space: nowrap;
          }

          .news-message.left-scroll {
            animation: slide-left 40s linear infinite;
          }

          .news-message.right-scroll {
            animation: slide-right 40s linear infinite; 
          }

          .news-message-text {
            font-size: 4.5em;
            font-weight: 100;
            padding-left: 1em; 
            margin: 0; 
          }

          @keyframes slide-left {
            from {
              transform: translateX(100%); 
            }
            to {
              transform: translateX(-100%); 
            }
          }

          @keyframes slide-right {
            from {
              transform: translateX(-100%); 
            }
            to {
              transform: translateX(100%); 
            }
          }
        `}
      </style>
    </section>
  );
};

export default ScrollingText;
